import { createStore } from 'vuex'

export default createStore({
    state: {
        operation:[],
        menuList:[],
        userInfo:{}
    },
    mutations: {
        setOperation(state,data){
            state.operation = data
        },
        setMenuList(state,data){
            state.menuList = data
        },
        setUserInfo(state,data){
            state.userInfo = data
        },
    },
    actions: {
    },
    modules: {
    }
})
